import gql from 'graphql-tag';

export default gql`
mutation createPdfExport($projectId: Int!, $includeUnlisted: Boolean, $renderMode: String, $pageSize: String, $showGated: Boolean, $showQr: Boolean) {
  exportPDF(object: { project_id: $projectId, include_unlisted: $includeUnlisted, render_mode: $renderMode, page_size: $pageSize, show_gated: $showGated, show_qr: $showQr }) {
    pdf_export_url
  }
}
`;
